document.addEventListener("DOMContentLoaded", () => {
    const variantOptionsWrapper = document.querySelectorAll(".custom-variant-picker .variant-option");
    const productObj = typeof product !== "undefined" ? product : {};
    const averageSavingsPerItemInPack = {};

    if (typeof product === "undefined") {
      console.error("Product is undefined. Exiting.");
      return;
    }
    productObj?.variants.forEach((variant) => {
        const originalPrice = variant.compare_at_price;
        const discountedPrice = variant.price;

        // Calcula el porcentaje de ahorro
        const savingsPercentage = ((originalPrice - discountedPrice) / originalPrice) * 100;
        const savingsFixed = originalPrice - discountedPrice;

        // Número de artículos en el paquete es igual al número en el título del paquete
        const numberOfItemsInPack = parseInt(variant.title.split(" ")[1]);

        const averageSavingsPerItem = savingsPercentage / numberOfItemsInPack;

        averageSavingsPerItemInPack[variant.title] = {
            pack: variant.title,
            averageSavings: `<b>${averageSavingsPerItem.toFixed(2)}%</b>`,
            fixedSaings:  `<b>${numberWithCommas(savingsFixed) + compareSymbol()}</b>`
        };
    });

    variantOptionsWrapper?.forEach((option) => {
        const optionLabel = option.querySelector('.option-label');

        const handleClick = (e) => {
            e.stopPropagation();
            const clickedPackTitle = optionLabel.textContent || optionLabel.innerText;
            if (averageSavingsPerItemInPack[clickedPackTitle]) {
                document.body.querySelector('.ahorro-pack__inner').innerHTML = `Estas ahorrando ${averageSavingsPerItemInPack[clickedPackTitle].pack == 'Producto' 
                ? averageSavingsPerItemInPack[clickedPackTitle].fixedSaings
                : averageSavingsPerItemInPack[clickedPackTitle].averageSavings}`
            }
        };

        option.removeEventListener("click", handleClick);
        option.addEventListener("click", handleClick);
    });


});